/* exapop — reveal-on-scroll + header behavior + the hero three-body "chaos -> harmony" canvas.
   CSS lives in assets/exapop-tokens.css and the section {% style %} blocks. */
(function () {
  function initReveal(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var els = root.querySelectorAll('.exapop .reveal:not(.in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initHeader() {
    var hdr = document.querySelector('[data-exapop-header]');
    if (!hdr || hdr._exapopInit) return;
    hdr._exapopInit = true;

    var onScroll = function () { hdr.classList.toggle('scrolled', window.scrollY > 40); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var toggle = hdr.querySelector('[data-exapop-menu-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var open = hdr.classList.toggle('menu-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
    hdr.querySelectorAll('[data-exapop-mobile-nav] a').forEach(function (a) {
      a.addEventListener('click', function () {
        hdr.classList.remove('menu-open');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* Hero three-body: chaotic cluster -> stable figure-eight choreography. */
  function init3Body(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var c = root.querySelector('canvas.exa-3body');
    if (!c || c._exa3) return;
    if (!c.offsetParent) return; // hidden (e.g. mobile) — skip
    c._exa3 = true;

    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = c.clientWidth || 520, H = c.clientHeight || 380;
    c.width = W * dpr; c.height = H * dpr;
    var ctx = c.getContext('2d'); ctx.scale(dpr, dpr);
    var cx = W * 0.5, cy = H * 0.5;

    var bodies = [
      { phase: 0,      col: '#57AEE2', nf: [1.7, 2.9, 0.6], np: [0.3, 1.1, 2.0] },
      { phase: 2.0944, col: '#C56A45', nf: [2.3, 1.3, 0.9], np: [1.7, 0.4, 2.6] },
      { phase: 4.1888, col: '#2A2018', nf: [1.1, 3.3, 0.5], np: [2.4, 2.0, 0.9] }
    ];
    function fig8(th) { var s = Math.sin(th), co = Math.cos(th), d = 1 + s * s; return { x: W * 0.42 * co / d, y: H * 0.62 * s * co / d }; }
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var omega = 0.85, chaosDur = 4.6, t0 = null;
    function noise(b, time, amt) {
      var nx = 0, ny = 0;
      for (var k = 0; k < 3; k++) { nx += Math.sin(time * b.nf[k] + b.np[k]); ny += Math.cos(time * b.nf[k] * 0.8 + b.np[k] * 1.3); }
      return { x: nx * amt * 34, y: ny * amt * 28 };
    }
    function pos(b, time) {
      var grow = reduce ? 1 : (0.25 + 0.75 * Math.min(1, time / chaosDur));
      var chaos = reduce ? 0 : Math.max(0, 1 - time / chaosDur);
      var f = fig8(b.phase + (reduce ? 0 : time * omega));
      var n = noise(b, time, chaos);
      return { x: cx + f.x * grow + n.x, y: cy + f.y * grow + n.y };
    }
    function drawBodies(ps) {
      ctx.strokeStyle = 'rgba(87,174,226,0.10)'; ctx.lineWidth = 1;
      ctx.beginPath(); ctx.moveTo(ps[0].x, ps[0].y); ctx.lineTo(ps[1].x, ps[1].y); ctx.lineTo(ps[2].x, ps[2].y); ctx.closePath(); ctx.stroke();
      bodies.forEach(function (b, i) {
        var p = ps[i];
        ctx.globalAlpha = 0.12; ctx.beginPath(); ctx.arc(p.x, p.y, 12, 0, 6.2832); ctx.fillStyle = b.col; ctx.fill();
        ctx.globalAlpha = 1; ctx.beginPath(); ctx.arc(p.x, p.y, 6, 0, 6.2832); ctx.fillStyle = b.col; ctx.fill();
      });
    }
    if (reduce) { drawBodies(bodies.map(function (b) { return pos(b, 0); })); return; }
    function frame(ts) {
      if (t0 === null) t0 = ts;
      var time = (ts - t0) / 1000;
      ctx.globalCompositeOperation = 'destination-out';
      ctx.fillStyle = 'rgba(0,0,0,0.12)'; ctx.fillRect(0, 0, W, H);
      ctx.globalCompositeOperation = 'source-over';
      drawBodies(bodies.map(function (b) { return pos(b, time); }));
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function init() { initReveal(); initHeader(); init3Body(); }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  /* Re-run when a section is re-rendered in the theme editor. */
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); initHeader(); init3Body(e.target); });
})();
